import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ArticleImage extends Component {
    render () {
	    let post = this.props.post;
	    if (post.hero_padding) {
		    
		    return (
			    <div>
			        {post.hero_padding &&
	    				<div className="c-article__image c-image" style={{paddingTop:post.hero_padding}}>
	    					<FadeIn className="c-page-header__image c-page-header__image--landscape" duration={250}>
								{onload => (
									<img
										alt={''} 
										src={post.hero_src} 
										srcSet={post.hero_srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						</div>
					}
				</div>
			)
		} else {
			return null;
		}
	};
};
